/***************************************************************************************************

 Copyright 2023-2024 Fannie Mae. All rights reserved.
 This software contains confidential information and trade secrets of Fannie Mae.
 Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.

 ****************************************************************************************************/

import {Component, OnInit} from "@angular/core";
import {MenuItem} from "@fm-ui-adk/components-3";
import {ApiService} from "../../services/api.service";
import {Utils} from '../../shared/utils';
import { EndpointsService } from "../../services/endpoints.service";

export interface CustomIcon {
  title?: string;
  icon?: string;
  noCaret?: boolean;
  url?: string;
}

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  dusGatewayUrl: any;
  isInternal : boolean = false;

  items: MenuItem[];

  userName = {
    "firstName": "",
    "lastName": ""
  };

  levelOneMenu = [
    {
      title: 'DUS Gateway®',
      href: '',
      list: [],
      external: true,
      target: '_blank'
    }
  ]

  constructor(private utils: Utils, private apiService: ApiService, private endpointsService: EndpointsService) {
  }

  ngOnInit() {

    this.items = [
      {
        label: 'Logout',
        icon: 'fmi fmi-sign-out',
        command: () => {
          this.update();
        }
      }
    ];
    // Subscribe and update the info on demand
    this.apiService.userDetailsSub.subscribe((userDetails) => {
      this.userName['firstName'] = userDetails.firstName;
      this.userName['lastName'] = userDetails.lastName;
      this.isInternal = userDetails.isInternalUser;

      if (this.isInternal) {
        this.dusGatewayUrl = this.endpointsService.getInternalDUSGatewayURL();
      }
      else {
        this.dusGatewayUrl = this.endpointsService.getExternalDUSGatewayURL();
      }

      this.levelOneMenu = [{
        title: 'DUS Gateway®',
        href: this.dusGatewayUrl,
        list: [],
        external: true,
        target: '_blank'
      }];
    })
  }

  update() {
    this.utils.logout();
  }
}
